import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import parser from 'html-react-parser';
import { useMemo } from 'react';

export const useDisableConfirmModal = () => {
  const { t } = useTranslation();

  const { year, month } = useMemo(() => {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
    };
  }, []);

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('business_document_setting_confirm_title'),
      body: (
        <div>
          {parser(
            t('business_document_setting_confirm_disable_body', {
              year: year.toString(),
              month: month.toString(),
            })
          )}
        </div>
      ),
      cancelButtonProps: {
        children: t('cancel'),
      },
      okButtonProps: {
        children: t('business_document_setting_confirm_disable_button'),
      },
      size: 'md',
    }),
    [month, t, year]
  );
  return useConfirmModal(args);
};
